<template>
  <div class="justify-center-mobile" style="display: flex; min-height: 100vh">
    <b-sidebar class="show-navbar-lg nav-mod-admin" visible no-header shadow>
      <nav class="mb-3">
        <b-nav vertical>
          <b-nav-item style="margin-right: 0px" :active="section === 'perfil'" @click="showSection('perfil')">{{$t('myProfile')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" :active="section === 'favoritos'" @click="showSection('favoritos')">{{$t('saveds')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" :active="section === 'notificaciones'" @click="showSection('notificaciones')">{{$t('myNotifications')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" v-if="$store.getters['forum/forumUserIsAdminRole']" :active="section === 'validaciones'" @click="showSection('validaciones')">{{$t('validations')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" v-if="$store.getters['forum/forumUserIsAdminRole']" :active="section === 'reportes'" @click="showSection('reportes')">{{$t('reports')}}</b-nav-item>
        </b-nav>
      </nav>
    </b-sidebar>
    <b-icon-three-dots-vertical v-b-toggle.sidebar-admin class="three-dots-admin show-navbar-mobile" scale="1.5"></b-icon-three-dots-vertical>
    <b-sidebar id="sidebar-admin" v-model="showSideBarAdmin" no-header shadow>
      <nav class="mb-3">
        <b-nav vertical>
          <b-nav-item style="margin-right: 0px" :active="section === 'perfil'" @click="showSection('perfil')">{{$t('myProfile')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" :active="section === 'favoritos'" @click="showSection('favoritos')">{{$t('saveds')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" :active="section === 'notificaciones'" @click="showSection('notificaciones')">{{$t('myNotifications')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" v-if="$store.getters['forum/forumUserIsAdminRole']" :active="section === 'validaciones'" @click="showSection('validaciones')">{{$t('validations')}}</b-nav-item>
        </b-nav>
      </nav>
      <base-button @click="showSideBarAdmin = false">{{$t('close')}}</base-button>
    </b-sidebar>
    <div class="flex-column column-content">
      <h1 style="margin-bottom: 2%;">{{sectionTitle}}</h1>
      <div v-if="section === 'perfil'">
        <div v-for="item in sectionInputs[section]" :key="item.id">
          <base-input class="centerInput" width50 :id="item.id" @keyup="showSaveBtn = true" :tooltip="item.tooltip" :readonly="item.readonly" :label="item.label" v-model="item.value" :placeholder="item.placeholder" :type="item.type"></base-input>
        </div>
        <base-button class="btn-control" v-if="showSaveBtn" @click="sendData">{{$t('save')}}</base-button>
        <base-button class="back-btn btn-control" gray outline @click="goBack">{{$t('back')}}</base-button>
      </div>
      <div v-if="section === 'notificaciones'">
        <div v-for="item in sectionInputs[section]" :key="item.id">
          <b-form-checkbox v-if="!item.customName" switch @change="notificationsSwitch(item.fn)" v-model="item.value"><span class="label-align" v-html="item.label"></span></b-form-checkbox>
          <v-select class="notificationsSelector" v-if="item.id.includes('receiveEmails') && item.value" @option:selected="showSaveBtn = true" v-model="emailsDaysInterval" :placeholder="$t('panelEmailInterval')" :options="emailsDaysIntervalSource" label="name" :reduce="x => x.days">
            <template #no-options="">
              {{$t('panelEmailInterval')}}
            </template>
          </v-select>
          <v-select class="notificationsSelector" v-if="item.id.includes('categories') && showCategoriesSelector" @option:selected="showSaveBtn = true" multiple v-model="categories" @search="getCategories" :placeholder="$t('panelEntryCategory')" :options="categoriesSource" filtered searchable label="name" :reduce="x => x.id">
            <template #no-options="">
              {{$t('panelEntryCategory')}}
            </template>
          </v-select>
          <v-select class="notificationsSelector" v-if="item.id.includes('tags') && showTagsSelector" multiple v-model="tags" @option:selected="showSaveBtn = true" @search="getTags" :placeholder="$t('panelEntryTags')" :options="tagsSource" filtered searchable label="name" :reduce="x => x.id">
            <template #no-options="">
              {{$t('panelEntryTags')}}
            </template>         
          </v-select>
        </div>
        <base-button class="btn-control" v-if="showSaveBtn" @click="sendData">{{$t('save')}}</base-button>
        <base-button class="back-btn btn-control" gray outline @click="goBack">{{$t('back')}}</base-button>
      </div>
      <div v-if="section === 'favoritos'">
        <b-nav style="margin-bottom: 2%;" class="centerInput">
          <b-nav-item style="margin-right: 0px;" :active="favouritesSectionSelected === 'entries'" @click="showFavouritesSection('entries')"><span class="black">{{$t('entries')}}</span></b-nav-item>
          <b-nav-item style="margin-right: 0px" :active="favouritesSectionSelected === 'messages'" @click="showFavouritesSection('messages')"><span class="black">{{$t('messages')}}</span></b-nav-item>
        </b-nav>
        <div v-if="favouritesSectionSelected === 'entries'">
          <forum-article-block v-if="$store.state.forum.articleData && $store.state.forum.articleData.length > 0" hideFooter></forum-article-block>
          <span v-if="noEntriesSaved">{{$t('noEntriesSaved')}}</span>
        </div>
        <div v-if="favouritesSectionSelected === 'messages'">
          <forum-message-block v-if="$store.state.forum.messages" hideOptions></forum-message-block>
          <span v-if="noMessagesSaved">{{$t('noMessagesSaved')}}</span>
        </div>
        <base-button class="back-btn-panel btn-control" gray outline @click="goBack">{{$t('back')}}</base-button>
      </div>
      <div v-if="section === 'validaciones'">
        <b-nav style="margin-bottom: 2%;" class="centerInput">
          <b-nav-item style="margin-right: 0px" :active="validationsSectionSelected === 'messages'" @click="showValidationsSection('messages')">{{$t('messages')}}</b-nav-item>
          <b-nav-item style="margin-right: 0px" :active="validationsSectionSelected === 'entries'" @click="showValidationsSection('entries')">{{$t('entries')}}</b-nav-item>
        </b-nav>
        <div v-if="validationsSectionSelected === 'messages'">
          <forum-message-block v-if="$store.state.forum.messages" hideOptions showValidateMessage @updateValidatedMessages="loadValidationsMessages"></forum-message-block>
          <span v-if="noMessagesPendingValidation">{{$t('noMessagesPendingValidation')}}</span>
        </div>
        <div v-if="validationsSectionSelected === 'entries'">
          <forum-article-block v-if="$store.state.forum.articleData && $store.state.forum.articleData.length > 0" hideFooter disableClick showValidateEntry @updateValidatedEntries="loadValidationsEntries"></forum-article-block>
          <span v-if="noEntriesPendingValidation">{{$t('noEntriesPendingValidation')}}</span>
        </div>
        <base-button class="back-btn-panel btn-control" gray outline @click="goBack">{{$t('back')}}</base-button>
      </div>
      <div v-if="section === 'reportes'">
        <div>
          <forum-message-block v-if="$store.state.forum.messages" hideOptions showReportMessage @updateReportedMessages="loadReportedMessages"></forum-message-block>
          <span v-if="noMessagesReported">{{$t('noMessagesReported')}}</span>
        </div>
        <base-button class="back-btn-panel btn-control" gray outline @click="goBack">{{$t('back')}}</base-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BNavbar, BCollapse, BSidebar, BNavbarBrand, BNavbarToggle, BNavbarNav, BNavItem, BNav, BFormCheckbox, BButton, IconsPlugin } from 'bootstrap-vue'
import BaseInput from '@/components/base/forms/BaseInput'
import BaseButton from '@/components/base/buttons/BaseButton'
import ForumArticleBlock from './ForumArticleBlock'
import ForumMessageBlock from './ForumMessageBlock'
import forumMixin from '@/mixins/forum.mixin'

export default {
  name: 'forum-control-panel',
  components: {
    BNav,
    BNavbar,
    BNavbarNav,
    BNavItem,
    BNavbarBrand,
    BNavbarToggle,
    BFormCheckbox,
    BaseInput,
    BaseButton,
    ForumArticleBlock,
    ForumMessageBlock,
    BCollapse,
    BSidebar,
    BButton,
    IconsPlugin
   },
   mixins: [forumMixin],
   data () {
    return {
      section: 'perfil',
      showSaveBtn: false,
      sectionTitle: null,
      favouritesSectionSelected: 'entries',
      validationsSectionSelected: 'messages',
      noEntriesSaved: false,
      noMessagesSaved: false,
      noMessagesPendingValidation: false,
      noMessagesReported: false,
      noEntriesPendingValidation: false,
      showSideBarAdmin: false,
      tags: [],
      tagsSource: [],
      tagsSourceFull: [],
      categories: [],
      categoriesSource: [],
      categoriesSourceFull: [],
      emailsDaysIntervalSource: [{name: this.$t('eachDay'), days: 1}, {name: this.$t('eachWeek'), days: 7}, {name: this.$t('eachMonth'), days: 30}],
      emailsDaysInterval: null,
      showTagsSelector: false,
      showCategoriesSelector: false,
      sectionInputs: {
        perfil: [
          {id: this.randomString('fullName_'), label: this.$t('name'), value: null, placeholder: this.$t('name'), type: 'text', readonly: true, tooltip: this.$t('infoName')},
          {id: this.randomString('nick_'), label: this.$t('userAlias'), value: null, placeholder: this.$t('userAlias'), type: 'text', readonly: false, tooltip: this.$t('infoNick')},
          {id: this.randomString('email_'), label: this.$t('notificationsEmail'), value: null, placeholder: this.$t('notificationsEmail'), type: 'text', readonly: false, tooltip: this.$t('infoEmail')}
        ],
        notificaciones: [
          {id: this.randomString('receiveEmails_'), label: this.$t('receiveEmails'), value: null},
          {id: this.randomString('emailsDaysInterval_'), customName: 'emailsDaysInterval'},
          {id: this.randomString('messagesReply_'), label: this.$t('messagesReply'), value: null},
          {id: this.randomString('newEntries_'), label: this.$t('newEntries'), value: null},
          {id: this.randomString('favouritesEntries_'), label: this.$t('answersOfFavouritesEntries'), value: null},
          {id: this.randomString('favouritesMessages_'), label: this.$t('answersOfFavouritesMessages'), value: null},
          {id: this.randomString('categories_'), label: this.$t('categories'), value: null, isList: true, fn: () => { this.showCategoriesSelector = !this.showCategoriesSelector; if (this.showCategoriesSelector) { this.getCategories() } }},
          {id: this.randomString('tags_'), label: this.$t('tags'), value: null, isList: true, fn: () => { this.showTagsSelector = !this.showTagsSelector; if (this.showTagsSelector) { this.getTags() } }}
        ]
      }
    }
  },
  created () {
    if (!this.$store.getters['session/isLogged']) {
      this.logIn()
      return
    }
    /* if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
    } */
    this.$store.state.forum.hideSearcher = false
    this.$store.state.forum.hideOutsideSearchBar = true
    this.$store.state.forum.messages = []
    let section = this.$route.params.section || 'perfil'
    this.showSection(section)
  },
  methods: {
    getSectionData () {
      this.$api.get(`/Forum/Panel/${this.section}`).then((response) => {
        let data = response.data[this.section]
        if (data) {
          for (let key in data) {
            let item = this.sectionInputs[this.section].find(item => item.id.includes(`${key}_`))
            if (item && item.isList) {
              item.value = data[key] && data[key].length > 0
              let selectorName = key.charAt(0).toUpperCase() + key.slice(1)
              this[`show${selectorName}Selector`] = item.value
              if (item.value) {
                this[`get${selectorName}`]()
              }
              this[key] = data[key]
            } else if (item) {
              if (item.customName) {
                this[item.customName] = data[key]
              } else {
                item.value = data[key]
              }
            }
          }
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    showFavouritesSection (section) {
      this.favouritesSectionSelected = section
      this[`loadFavourites${section.charAt(0).toUpperCase() + section.slice(1)}`]()
    },
    showValidationsSection (section) {
      this.validationsSectionSelected = section
      this[`loadValidations${section.charAt(0).toUpperCase() + section.slice(1)}`]()
    },
    loadFavouritesEntries () {
      this.$api.get('/Forum/GetFavouritesEntries').then((response) => {
        if (response.data && response.data.entryData.length > 0) {
          this.noEntriesSaved = false
        } else {
          this.noEntriesSaved = true
        }
        this.$store.state.forum.articleData = response.data.entryData
      })
    },
    loadFavouritesMessages () {
      this.$api.get('/Forum/GetFavouritesMessages').then((response) => {
        if (response.data && response.data.entryMessageData.length > 0) {
          this.noMessagesSaved = false
        } else {
          this.noMessagesSaved = true
        }
        this.$store.state.forum.messages = response.data.entryMessageData
      })
    },
    loadValidationsMessages () {
      this.$api.get('/Forum/GetMessagesPendingValidation').then((response) => {
        if (response.data && response.data.entryMessageData.length > 0) {
          this.noMessagesPendingValidation = false
        } else {
          this.noMessagesPendingValidation = true
        }
        this.$store.state.forum.messages = response.data.entryMessageData
      })
    },
    loadReportedMessages () {
      this.$api.get('/Forum/GetReportedMessages').then((response) => {
        if (response.data && response.data.entryMessageData.length > 0) {
          this.noMessagesReported = false
        } else {
          this.noMessagesReported = true
        }
        this.$store.state.forum.messages = response.data.entryMessageData
      })
    },
    loadValidationsEntries () {
      this.$api.get('/Forum/GetEntriesPendingValidation').then((response) => {
        if (response.data && response.data.entryData.length > 0) {
          this.noEntriesPendingValidation = false
        } else {
          this.noEntriesPendingValidation = true
        }
        this.$store.state.forum.articleData = response.data.entryData
      })
    },
    sendData () {
      let data = {}
      if (this.section === 'perfil') {
        data.nick = this.sectionInputs.perfil.find(item => item.id.includes('nick')).value
        data.email = this.sectionInputs.perfil.find(item => item.id.includes('email')).value
        if (!data.nick || !data.email) {
          this.$store.dispatch('showDangerAlert', this.$t('fieldEmpty'))
          return
        }
      } else if (this.section === 'notificaciones') {
        if (this.sectionInputs.notificaciones.find(item => item.id.includes('receiveEmails')).value && !this.emailsDaysInterval) {
          this.$store.dispatch('showDangerAlert', this.$t('mustSelectEmailsInterval'))
          return
        }
        if (this.sectionInputs.notificaciones.find(item => item.id.includes('categories')).value && this.categories.length === 0) {
          this.$store.dispatch('showDangerAlert', this.$t('mustSelectCategory'))
          return
        }
        if (this.sectionInputs.notificaciones.find(item => item.id.includes('tags')).value && this.tags.length === 0) {
          this.$store.dispatch('showDangerAlert', this.$t('mustSelectTags'))
          return
        }
        data.receiveEmails = this.sectionInputs.notificaciones.find(item => item.id.includes('receiveEmails')).value
        data.emailsDaysInterval = data.receiveEmails ? this[this.sectionInputs.notificaciones.find(item => item.id.includes('emailsDaysInterval')).customName] : null
        data.messagesReply = this.sectionInputs.notificaciones.find(item => item.id.includes('messagesReply')).value
        data.newEntries = this.sectionInputs.notificaciones.find(item => item.id.includes('newEntries')).value
        data.favouritesEntries = this.sectionInputs.notificaciones.find(item => item.id.includes('favouritesEntries')).value
        data.favouritesMessages = this.sectionInputs.notificaciones.find(item => item.id.includes('favouritesMessages')).value
        data.categories = this.sectionInputs.notificaciones.find(item => item.id.includes('categories')).value ? this.categories : []
        data.tags = this.sectionInputs.notificaciones.find(item => item.id.includes('tags')).value ? this.tags : []
      }
      this.$api.post(`/Forum/Panel/${this.section}`, data).then((response) => {
        if (response.data) {
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          this.showSaveBtn = false
          if (data.nick) {
            this.$store.state.forum.userBasicInfo.nick = data.nick
          }
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    goBack () {
      this.$router.push(this.getPathUrl())
    },
    showSection (section) {
      this.showSideBarAdmin = false
      this.section = section
      this.$store.state.forum.messages = []
      switch (section) {
        case 'perfil':
        case 'notificaciones':
          this.getSectionData()
          break
        case 'favoritos':
          this.showFavouritesSection('entries')
          break
        case 'validaciones':
          this.loadValidationsMessages()
          break
        case 'reportes':
          this.loadReportedMessages()
          break
        default:
          this.getSectionData()
      }
      this.getSectionTitle()
    },
    getSectionTitle () {
      switch (this.section) {
        case 'perfil':
          this.sectionTitle = this.$t('myProfile')
          break
        case 'favoritos':
          this.sectionTitle = this.$t('saveds')
          break
        case 'notificaciones':
          this.sectionTitle = this.$t('myNotifications')
          break
        case 'validaciones':
          this.sectionTitle = this.$t('validations')
          break
        case 'reportes':
          this.sectionTitle = this.$t('reports')
          break
      }
    },
    randomString (prefix) {
      return Math.random().toString(36).replace('0.', prefix || '')
    },
    getTags (search, loading) {
      if (search) {
        loading(true)
        this.tagsSource = this.tagsSourceFull.filter(item => item.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
        loading(false)
      } else if (this.tagsSourceFull.length === 0) {
        this.$api.get('Forum/SearchEntryTag').then(response => {
          this.tagsSourceFull = response.data
          this.tagsSource = response.data
        })
      }
    },
    getCategories (search, loading) {
      if (search) {
        loading(true)
        this.categoriesSource = this.categoriesSourceFull.filter(item => item.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
        loading(false)
      } else if (this.categoriesSourceFull.length === 0) {
        this.$api.get('Forum/SearchEntryCategory').then(response => {
          this.categoriesSourceFull = response.data
          this.categoriesSource = response.data
        })
      }
    },
    notificationsSwitch (fn) {
      if (fn) {
        fn()
      }
      this.showSaveBtn = true
    }
  },
  beforeDestroy () {
    this.$store.state.forum.hideOutsideSearchBar = false
  }
}
</script>
<style lang="scss">
.nav-mod-admin {
  z-index: inherit !important;
  position: relative !important;
  width: 15% !important;
  // border: 1px solid #3238C4;
  >div {
    position: inherit !important;
    min-height: 100vh !important;
    margin: 7% 1% 0 0 !important;
  }
}
.column-content {
  margin-top: 1vh;
  width: 75%;
}
.centerInput {
  display: flex;
  justify-content: center;
}

.text-align-left {
  text-align: left;
}

.label-align {
  min-width: 300px;
  display: block;
  text-align: left;
}

.show-navbar-mobile {
  display: none !important;
  @include media(mobile) {
    display: inline-block !important;
  }
}

.show-navbar-lg{
  display: none !important;
  @include media(desktop) {
    display: inline-block !important;
  }
}

.justify-center-mobile {
  @include media(mobile, tablets) {
    margin-top: 2vh !important;
    justify-content: center;
  }
}

.three-dots-admin{
  position: absolute;
  left: 7%;
  margin-top: 2%;
  cursor: pointer;
}

div.b-sidebar{
  margin-top: 0px !important;
}

.btn-control{
  margin-top: 3vh !important;
}

.black {
  color: $black;
}

.notificationsSelector {
  width: auto;
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-community/forum/ForumControlPanel.vue